import { batch, connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import dayjs from 'dayjs';
import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import {
    getNextAvailable,
    getAdvisorsTransportOptions,
    getPPDAvailability,
} from '../../shared/BackendCalls/SharedBackendGets';

import { formatDateLong } from '../../shared/Utils/TimeLocalization';
import {
    setConciergePhoneNumber,
    setCustomerEmail,
    setCustomerFirstName,
    setCustomerLastName,
    setCustomerPhoneNumber,
    setPickupAddress,
    setTransportation,
} from '../../Redux/ActionCreator';
import Contact from './Contact/Contact';
import Day from './Dates/Day';
import Month from './Dates/Month';
import Details from './Details/Details';
import store from '../../Redux/Store';
import Time from './Dates/Time';
import {
    AuthenticatedFlow,
    AuthenticatedOCPlus,
    DealerFlowUs,
    EditAppointmentFlow,
} from '../../shared/RoutingFlow/FlowComponentsConstants';
import AnalyticsService from '../../shared/Utils/analytics.service';
import { adobeAnalytics } from '../../shared/Utils/Utils';
import { getPhoneNum } from './Dealership/DealershipPhone';

import DealerShipInformation from './Dealership/DealerShipInformation';
import { MOBILE_SERVICE, PREMIUM_CONCIERGE, PREMIUM_CONCIERGE_WITH_LOANER } from './AppointmentConstants';
import CircularProgress from '@material-ui/core/CircularProgress';
import ErrorDisplay from '../ErrorPage/ErrorDisplay';
import { useFlags } from 'launchdarkly-react-client-sdk';
const customParseFormat = require('dayjs/plugin/customParseFormat');
const appointmentConstants = require('../Appointment/AppointmentConstants');

dayjs.extend(customParseFormat);

const Appointment = (props) => {
    const {
        availabilityErrorFlag,
        availableDates,
        countryOptions,
        customerEmail,
        customerFirstName,
        customerLastName,
        customerPhoneNumber,
        dealerSummary,
        editAppt,
        email,
        firstAvailDate,
        firstName,
        flowSource,
        history,
        lastName,
        loadingFlag,
        networkErrorFlag,
        optionCallLoading,
        phoneCell,
        phoneDay,
        phoneEvening,
        pickupAddress,
        showSpinner,
        transportation,
        translations,
        vCountry,
        setConciergePhoneNumber,
        setCustomerEmail,
        setCustomerFirstName,
        setCustomerLastName,
        setCustomerPhoneNumber,
        enableNoAvailabilityErrorByBac,
    } = props;

    const { enableNoAvailabilityError } = useFlags();

    const hasInitialized = useRef(false);
    const hasSetCustomerInfo = useRef(false);
    const loadStartedRef = useRef(false);
    const hasMounted = useRef(false);

    const [availabilityReady, setAvailabilityReady] = useState(false);

    const isEditAppointmentFlow = flowSource === EditAppointmentFlow;
    const availabilityInFlight = showSpinner || loadingFlag;
    const hasNoNextAvailable = !firstAvailDate || firstAvailDate === 'null';
    const mobilePhoneLink = (
        <a href={`tel:${getPhoneNum(dealerSummary, vCountry)}`} target="_blank" rel="noreferrer">
            {`${getPhoneNum(dealerSummary, vCountry)}`}
        </a>
    );

    // Backend returns a day per slot even when unavailable, so treat "every day has no times" as empty
    const hasNoCalendarDates =
        !availableDates ||
        availableDates.length === 0 ||
        availableDates.every((day) => !day.time || day.time.length === 0);
    const showNoAvailabilityError =
        availabilityReady &&
        hasNoNextAvailable &&
        hasNoCalendarDates &&
        enableNoAvailabilityError &&
        enableNoAvailabilityErrorByBac;

    // Desktop: number is plain (non-clickable). Mobile: number is dropped here and rendered as a link.
    const contactDealerMessage = (translations.DMS_ERROR_CONTACT_DEALER || 'DMS_ERROR_CONTACT_DEALER')
        .replace('{{dealership}}', dealerSummary?.name || '')
        .replace('{{number}}', getPhoneNum(dealerSummary, vCountry));
    const partialContactDealerMessage = (translations.DMS_ERROR_CONTACT_DEALER || 'DMS_ERROR_CONTACT_DEALER')
        .replace('{{dealership}}', dealerSummary?.name || '')
        .replace('{{number}}', '');

    const findPrepopulatedPhoneNumber = (cell, day, evening) => {
        if (cell) {
            return cell;
        }
        if (day) {
            return day;
        }
        if (evening) {
            return evening;
        }
        return cell;
    };

    const setCustomerInfo = (emailValue, firstNameValue, lastNameValue, phoneNumber) => {
        if (!emailValue) {
            setCustomerEmail(email);
        }

        if (!firstNameValue) {
            setCustomerFirstName(firstName);
        }

        if (!lastNameValue) {
            setCustomerLastName(lastName);
        }

        if (!phoneNumber) {
            const phone = findPrepopulatedPhoneNumber(phoneCell, phoneDay, phoneEvening);
            setCustomerPhoneNumber(phone);
            setConciergePhoneNumber(phone);
        }
    };

    if (
        !hasSetCustomerInfo.current &&
        (flowSource === AuthenticatedFlow || flowSource === DealerFlowUs || flowSource === AuthenticatedOCPlus)
    ) {
        hasSetCustomerInfo.current = true;
        setCustomerInfo(customerEmail, customerFirstName, customerLastName, customerPhoneNumber);
    }

    // Initialization side effects run once on mount; ref guard also blocks StrictMode's dev double-invoke.
    useEffect(() => {
        if (hasInitialized.current) {
            return;
        }
        hasInitialized.current = true;
        const appointmentContainer = document.querySelector('.appointment-main-container');
        if (appointmentContainer) {
            appointmentContainer.scrollIntoView({ behavior: 'auto', block: 'start' });
        } else {
            window.scrollTo(0, 0);
        }

        if (
            (transportation.code === MOBILE_SERVICE ||
                transportation.code === PREMIUM_CONCIERGE ||
                transportation.code === PREMIUM_CONCIERGE_WITH_LOANER) &&
            flowSource !== EditAppointmentFlow &&
            !pickupAddress
        ) {
            batch(() => {
                store.dispatch(setTransportation('false'));
                store.dispatch(setPickupAddress('empty'));
            });
        }

        if (dealerSummary) {
            if (
                transportation.code === appointmentConstants.PREMIUM_CONCIERGE ||
                editAppt.transportationOption === appointmentConstants.PREMIUM_CONCIERGE
            ) {
                //First PP&D availability call to get first available date for label
                getPPDAvailability(dealerSummary.bac, null, dayjs(), 'ppdFirstAvail');
            } else {
                getNextAvailable(dealerSummary.bac);
            }
            getAdvisorsTransportOptions();
        }
    }, []);

    useEffect(() => {
        if (availabilityInFlight) {
            loadStartedRef.current = true;
        } else if (loadStartedRef.current) {
            setAvailabilityReady(true);
        }
    }, [availabilityInFlight]);

    // componentDidMount (previously) initialize analytics once after first render
    useEffect(() => {
        if (AnalyticsService().loggingEnabled) {
            $('body').append(adobeAnalytics('form-step'));
            console.log('Analytics Added for Page to : Appointment using JQuery');
        }
    }, []);

    useEffect(() => {
        if (!hasMounted.current) {
            hasMounted.current = true;
            return;
        }
        if (availabilityErrorFlag) {
            history.push({ pathname: '/Error', state: { errorSource: 'appointment' } });
        }
    }, [availabilityErrorFlag, history]);

    return (
        <>
            {networkErrorFlag && <Redirect to="/Error" />}
            <div className="appointment-main-container">
                <div className="appointment-main-header headline2">
                    {isEditAppointmentFlow ? translations.MODIFY_APPOINTMENT : translations.APP_OPTIONS}
                </div>
                <div className="appointment-headline-border headline-border" />
                <DealerShipInformation />
                <Details customerPhoneNumber={customerPhoneNumber} />{' '}
                {showNoAvailabilityError ? (
                    <>
                        <ErrorDisplay
                            className="appointment-error"
                            title={
                                translations.NO_AVAILABILITY ? translations.NO_AVAILABILITY : 'No availability found'
                            }
                        >
                            <p className="error-message-contact-dealer hide-on-mobile">{contactDealerMessage}</p>
                            <p className="error-message-contact-dealer-mobile hide-on-desktop">
                                {partialContactDealerMessage} {mobilePhoneLink}
                            </p>
                        </ErrorDisplay>
                    </>
                ) : (
                    <>
                        {transportation.code &&
                        (transportation.code === MOBILE_SERVICE ||
                            transportation.code === PREMIUM_CONCIERGE_WITH_LOANER ||
                            transportation.code === PREMIUM_CONCIERGE) &&
                        !pickupAddress ? null : optionCallLoading || !availabilityReady ? (
                            <CircularProgress />
                        ) : (
                            <>
                                <div className="appointment-header headline2">
                                    {isEditAppointmentFlow ? translations.MODIFY_APP_DT : translations.APP_DT}
                                </div>
                                <div className="appointment-headline-border headline-border apt-headline2" />
                                {(availabilityErrorFlag && !countryOptions.HIDE_FIRST_AVAILABLE === 'true') ||
                                !firstAvailDate ||
                                firstAvailDate === 'null' ? (
                                    (transportation.code === 'PREMIUM_CONCIERGE' ||
                                        transportation.code === 'CADILLAC_PREMIUM_CONCIERGE') && (
                                        <>
                                            <div>{translations.PPD_NO_AVAIL}</div>
                                        </>
                                    )
                                ) : (
                                    <div className="appointment-first-avail-container">
                                        {translations.FIRST_AVAILABLE} {formatDateLong(firstAvailDate)}
                                    </div>
                                )}
                                <Month />
                                <Day />
                                <Time />
                            </>
                        )}

                        <Contact customerPhoneNumber={customerPhoneNumber} />
                    </>
                )}
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    availabilityErrorFlag: state.appointmentReducer.availabilityErrorFlag,
    availableDates: state.appointmentReducer.availableDates,
    countryOptions: state.countryOptionsReducer.countryOptions,
    customerEmail: state.appointmentReducer.customerEmail,
    customerFirstName: state.appointmentReducer.customerFirstName,
    customerLastName: state.appointmentReducer.customerLastName,
    customerPhoneNumber: state.appointmentReducer.customerPhoneNumber,
    dealerSummary: state.prefillReducer.dealerSummaryObject.dealershipSummary,
    email: state.prefillReducer.email,
    firstAvailDate: state.appointmentReducer.firstAvailDate,
    firstName: state.prefillReducer.firstName,
    flowSource: state.prefillReducer.flowSource,
    lastName: state.prefillReducer.lastName,
    networkErrorFlag: state.appointmentReducer.networkErrorFlag,
    phoneCell: state.prefillReducer.phoneCell,
    phoneDay: state.prefillReducer.phoneDay,
    phoneEvening: state.prefillReducer.phoneEvening,
    startDate: state.appointmentReducer.startDate,
    translations: state.countryOptionsReducer.translations,
    transportation: state.appointmentReducer.transportation,
    editAppt: state.prefillReducer.editAppointmentObject,
    vCountry: state.prefillReducer.country,
    pickupAddress: state.appointmentReducer.pickupAddress,
    transportationCallComplete: state.appointmentReducer.transportationCallComplete,
    optionCallLoading: state.appointmentReducer.optionCallLoading,
    showSpinner: state.ossAppGlobals.showSpinner,
    loadingFlag: state.appointmentReducer.loadingFlag,
    enableNoAvailabilityErrorByBac: state.appointmentReducer.enableNoAvailabilityErrorByBac,
});

export default connect(mapStateToProps, {
    setConciergePhoneNumber,
    setCustomerEmail,
    setCustomerFirstName,
    setCustomerLastName,
    setCustomerPhoneNumber,
})(Appointment);
